module.exports = __webpack_public_path__ + "static/media/logo_vacancy.e018ca77.png";